import { PayloadAction } from "@reduxjs/toolkit";
import { rdsEvent_Dto } from "../interfaces/dtos/rdsEvent";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { rdsMeeting_Dto } from "../interfaces/dtos/rdsMeeting";
import { Theme } from "@mui/material";
import { timezones } from "../components/shared/commonConstants";

dayjs.extend(utc);
dayjs.extend(timezone);

export const getEventDesc = (event?: rdsEvent_Dto) => {
    if (!event) { return ""; }
    return `${dayjs(event.dateTime).format("HH:mm")} ${event.name}`;
}

export const getEventDescForTitle = (meeting?: rdsMeeting_Dto, event?: rdsEvent_Dto) => {
    if (!meeting || !event) { return ""; }
    return `${meeting?.description} Race ${event?.number} '${dayjs(event?.dateTime).format("DD/MM/YYYY")}' - ${dayjs(event.dateTime).format("HH:mm")} ${event.name}`;
}

export const getCountryCodeForFlag = (countryCode: string) => {
    return countryCode === 'UK' ? 'GB' : countryCode;
}

export const toUKDate = (dateTime?: Date | string) => {
    return dateTime ?
        dayjs(dateTime).tz(timezones.UK).format('YYYY-MM-DDTHH:mm:ss.SSSSSS') :
        undefined;
}

export const segmentHeaderDefault = (theme: Theme) => {
    return `linear-gradient(to right, ${theme.palette.secondary.dark}, ${theme.palette.secondary.main})`
}

export const dispatchIsSuccessful = (
    // allow any paramater
    // eslint-disable-next-line
    action: PayloadAction<any, string, { requestStatus: 'fulfilled' | 'rejected' }>
) => {
    return action.meta.requestStatus === 'fulfilled';
}

export const toTitleCase = (str: string) => {
    return str.replace(
        /\w\S*/g,
        text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    );
}

export const compareDateStrings = (date1String?: string, date2String?: string) => {
    if (date1String === undefined || date1String === null) return 0;
    if (date2String === undefined || date2String === null) return 0;
    const date1 = new Date(date1String);
    const date2 = new Date(date2String);
    return date1.getTime() - date2.getTime();
}

export const fileVersionAppendix = () => {
    // When there's a new version, add the version to the download filename to avoid any caching from the browser
    const fileVersion: string = import.meta.env.VITE_REACT_APP_VERSION.replaceAll(".", "_");
    return `?v=${fileVersion}`;
}
